import React from "react";
import { BiChat } from "react-icons/bi"; // Chat
import { AiOutlineBarChart, AiOutlineEye } from "react-icons/ai"; // Insights and Visibility
import { FiSettings } from "react-icons/fi"; // Settings
import { GiElectric, GiRobotGolem } from "react-icons/gi"; // Bolt and Smart Toy
import { MdDashboard } from "react-icons/md"; // Dashboard
import { FaRegHandshake } from "react-icons/fa"; // Handshake

const Features: React.FC = () => {
  const cards = [
    {
      title: "AI Chatbot",
      features: [
        {
          icon: <GiRobotGolem size={24} />,
          label: "AI Tailored Chatbot",
        },
        { icon: <BiChat size={24} />, label: "Effortless Conversations" },
        { icon: <GiElectric size={24} />, label: "One-Click Leads" },
        { icon: <FaRegHandshake size={24} />, label: "Sales Takeover" },
      ],
    },
    {
      title: "Smart Insights",
      features: [
        {
          icon: <AiOutlineBarChart size={24} />,
          label: "Live Visitor Insights",
        },
        { icon: <MdDashboard size={24} />, label: "Dynamic Dashboard" },
        { icon: <FiSettings size={24} />, label: "CRM Automation" },
        { icon: <AiOutlineEye size={24} />, label: "Instant AI Lead Capture" },
      ],
    },
  ];

  return (
    <div className="flex flex-col text-gray-700 max-w-4xl mx-auto lg:flex-row justify-center items-center gap-10 px-4 py-8">
      {cards.map((card, cardIndex) => (
        <div
          key={cardIndex}
          className="bg-white rounded-2xl shadow-lg p-6 w-full max-w-md md:max-w-xl"
        >
          <h2 className="text-[20px] sm:text-[28px] font-inter font-[700] text-center mb-4">
            {card.title}
          </h2>
          <div className="grid grid-cols-2 gap-4">
            {card.features.map((feature, index) => {
              return (
                <div
                  key={index}
                  className="flex flex-col items-center justify-center text-center"
                >
                  <div className="flex items-center justify-center w-16 h-16 bg-gray-100 rounded-full shadow-md text-[#06526d]">
                    {feature.icon}
                  </div>
                  <span className="mt-2 text-[14px] text-[#000] font-[500]">
                    {feature.label || "Label Missing"}
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
};

export default Features;
